"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constant = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  step: 0,
  members: {
    nrAdults: 1,
    nrChild: 0
  },
  comment: "",
  email: "",
  phone: "",
  countryCode: "",
  date: {},
  queryType: "",
  enquiryFor: {},
  source: "",
  userDetails: {},
  registering: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var actions = arguments.length > 1 ? arguments[1] : undefined;

  switch (actions.type) {
    case _constant.NEXT_STEP:
      return _objectSpread({}, state, {
        step: state.step + 1
      });

    case _constant.LAST_STEP:
      return _objectSpread({}, state, {
        step: 3
      });

    case _constant.PREV_STEP:
      return _objectSpread({}, state, {
        step: state.step <= 0 ? 0 : state.step - 1
      });

    case _constant.MEMBERS:
      return _objectSpread({}, state, {
        nrAdults: actions.payload.nrAdults,
        nrChild: actions.payload.nrChild
      });

    case _constant.USER_DETAILS:
      return _objectSpread({}, state, {
        userDetails: actions.payload
      });

    case _constant.DATE:
      return _objectSpread({}, state, {
        date: actions.payload
      });

    case _constant.ENQUIRY_FOR:
      return _objectSpread({}, state, {
        enquiryFor: actions.payload
      });

    case _constant.EMAIL:
      return _objectSpread({}, state, {
        email: actions.payload
      });

    case _constant.PHONE:
      return _objectSpread({}, state, {
        phone: actions.payload
      });

    case _constant.COUNTRY_CODE:
      return _objectSpread({}, state, {
        countryCode: actions.payload
      });

    case _constant.COMMENT:
      return _objectSpread({}, state, {
        comment: actions.payload
      });

    case _constant.SOURCE:
      return _objectSpread({}, state, {
        source: actions.payload
      });

    case _constant.QUERY_TYPE:
      return _objectSpread({}, state, {
        queryType: actions.payload
      });

    case _constant.REGISTER_ENQUIRY_LOADER:
      return _objectSpread({}, state, {
        registering: actions.payload
      });

    default:
      return state;
  }
};

var rootReducers = reducer;
var _default = rootReducers;
exports.default = _default;